import React from 'react';
import '../App.css';

const HowItWorks = () => {
    return (
        <div className="hiw-page">
            <div className="hiw-hero">
                <h1>How <span className="gradient-text">TriggerKart</span> Works</h1>
                <p>From comment to checkout in seconds. Here is the full breakdown.</p>
            </div>

            <div className="hiw-container">
                {/* Step 1 */}
                <div className="hiw-row">
                    <div className="hiw-content">
                        <div className="hiw-step-badge">Step 1</div>
                        <h2>Create Your Merchant Account</h2>
                        <p>Sign up in seconds. We create a specialized dashboard for you to manage your products, automation rules, and sales analytics.</p>
                    </div>
                    <div className="hiw-visual">
                        <div className="mock-card user-card">
                            <span className="mock-avatar">👤</span>
                            <div className="mock-lines">
                                <span className="line long"></span>
                                <span className="line short"></span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Step 2 */}
                <div className="hiw-row reverse">
                    <div className="hiw-content">
                        <div className="hiw-step-badge">Step 2</div>
                        <h2>Upload Your Catalog</h2>
                        <p>Add your products manually or bulk upload. Include prices, images, and description. This serves as the source of truth for your sales.</p>
                    </div>
                    <div className="hiw-visual">
                        <div className="mock-grid">
                            <div className="mock-item">👕</div>
                            <div className="mock-item">👟</div>
                            <div className="mock-item">👜</div>
                            <div className="mock-item">🕶️</div>
                        </div>
                    </div>
                </div>

                {/* Step 3 */}
                <div className="hiw-row">
                    <div className="hiw-content">
                        <div className="hiw-step-badge">Step 3</div>
                        <h2>Connect Instagram</h2>
                        <p>Securely link your Instagram Business account. We use official Meta APIs to listen for comments on your posts in real-time.</p>
                    </div>
                    <div className="hiw-visual">
                        <div className="mock-insta-btn">
                            <span className="insta-icon">📷</span> Connect Instagram
                        </div>
                    </div>
                </div>

                {/* Step 4 */}
                <div className="hiw-row reverse">
                    <div className="hiw-content">
                        <div className="hiw-step-badge">Step 4</div>
                        <h2>Post & Share</h2>
                        <p>Post your content as usual. In the caption, tell your customers to comment a specific keyword (e.g., "BUY") to get the link.</p>
                    </div>
                    <div className="hiw-visual">
                        <div className="mock-post">
                            <div className="mock-post-img"></div>
                            <div className="mock-caption">
                                <span className="user-name">Your Customer</span> Comment "LINK" to buy!
                            </div>
                        </div>
                    </div>
                </div>

                {/* Step 5 */}
                <div className="hiw-row">
                    <div className="hiw-content">
                        <div className="hiw-step-badge">Step 5</div>
                        <h2>Instant Auto-Match</h2>
                        <p>Our engine detects the keyword instantly. It matches the comment to the correct product in your catalog.</p>
                    </div>
                    <div className="hiw-visual">
                        <div className="mock-match">
                            <div className="match-bubble">Your Customer: "LINK"</div>
                            <div className="match-arrow">⚡</div>
                            <div className="match-success">Match Found!</div>
                        </div>
                    </div>
                </div>

                {/* Step 6 */}
                <div className="hiw-row reverse">
                    <div className="hiw-content">
                        <div className="hiw-step-badge">Step 6</div>
                        <h2>Direct Message Checkout</h2>
                        <p>We send a DM to the customer immediately with a direct checkout link. They buy without ever leaving the flow.</p>
                    </div>
                    <div className="hiw-visual">
                        <div className="mock-dm">
                            <div className="dm-header">Direct Message</div>
                            <div className="dm-msg">
                                Here is the link to purchase! 👇
                                <br />
                                <span className="dm-link">triggerkart.com/buy/...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HowItWorks;
